import {observable, action, computed, makeObservable} from 'mobx';

export class ContainersCond {
    @observable numOfInputs;
    @observable id;
    @observable fieldToShowSelected;
    @observable opSelected;
    @observable firstInput;
    @observable secondInput;
    zoomType;
    // TODO: currently width is not in use
    width;

    constructor(cond, idx?) {
        makeObservable(this);
        this.id = idx;
        this.width = cond.width;
        this.zoomType = cond.zoomType;
        this.setFirstInput(cond.value);
        this.setSecondInput(cond.secvalue);
        this.setFieldToShow(cond.field);
        this.setOp(cond.operator);
        this.setNumOfInputs(cond.numOfInputs ? cond.numOfInputs : 0);
    }

    @computed get showFirstInput() {
        return this.numOfInputs >= 1;
    }

    @computed get showSecondInput() {
        return this.numOfInputs >= 2;
    }

    @action setNumOfInputs(value) {
        this.numOfInputs = value;
    }

    @action setFieldToShow(value) {
        this.fieldToShowSelected = value;
    }

    @action setOp(value) {
        this.opSelected = value;
    }

    @action setFirstInput(value) {
        this.firstInput = value;
    }

    @action setSecondInput(value) {
        this.secondInput = value;
    }
}
